import { PLAYER_FINDER_SUPPORT_URL } from '@sportninja/common/features/playerFinder/constants'
import { TEAM_BUDGET_SUPPORT_URL } from '@sportninja/common/features/team-balance/constants'
import type { RegistrationSubTab } from '../utils/registrationSubTabs'

export interface RegistrationSectionHeaderConfig {
  titleKey: string
  subtitleKey: string
  helpLabelKey: string
  helpUrl: string
  isBeta: boolean
}

/**
 * The header shown above each Registration tab section's content (or its empty
 * state). Billing has none — it renders straight under the scope row.
 */
export const REGISTRATION_SECTION_HEADERS: Record<
  RegistrationSubTab,
  RegistrationSectionHeaderConfig | null
> = {
  'command-center': {
    titleKey: 'common:commandCenter',
    subtitleKey: 'common:teamBudgetSectionSubtitle',
    helpLabelKey: 'common:teamBudgetSectionHelp',
    helpUrl: TEAM_BUDGET_SUPPORT_URL,
    isBeta: true,
  },
  billing: null,
  'player-finder': {
    titleKey: 'common:teamPlayerFinderTab',
    subtitleKey: 'common:teamPlayerFinderSectionSubtitle',
    helpLabelKey: 'common:teamPlayerFinderSectionHelp',
    helpUrl: PLAYER_FINDER_SUPPORT_URL,
    isBeta: true,
  },
}
